// RaffleScreen.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Copy, ArrowLeft, Gift } from 'lucide-react';
import '../styles/Gift.css';
import Logo from '../assets/logo.svg';
import { getReffCount, getAllReffCount } from '../api';

function RaffleScreen({ telegramId }) {
  const navigate = useNavigate();
  const [referralCount, setReferralCount] = useState(null);
  const [totalReferrals, setTotalReferrals] = useState(0);

  const referralLink = `https://t.me/SuprunKEY_bot?start=ref_${telegramId}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const myData = await getReffCount(telegramId);
        setReferralCount(myData.referral_count ?? 0);
        // setReferralCount(4);

        const allData = await getAllReffCount();
        setTotalReferrals(allData.count ?? 0);
        // setTotalReferrals(360);
      } catch (error) {
        console.error('Ошибка загрузки данных розыгрыша:', error);
        setReferralCount(0);
        setTotalReferrals(0);
      }
    };

    fetchData();
  }, [telegramId]);

  // Определяем, какой уровень сейчас АКТИВНЫЙ (следующий)
  const getActiveLevel = () => {
    if (totalReferrals >= 610) return 4; // главный приз уже достигнут
    if (totalReferrals >= 250) return 3; // следующий — iPhone 17
    if (totalReferrals >= 150)  return 2; // следующий — Watch 11
    return 1;                            // следующий — AirPods Pro
  };

  const activeLevel = getActiveLevel();

  // Для текста "До следующего приза"
  const getNextThreshold = () => {
    if (totalReferrals < 150) return 150;
    if (totalReferrals < 250) return 250;
    if (totalReferrals < 610) return 610;
    return null; // если уже достигнут максимум
  };

  const nextThreshold = getNextThreshold();

  return (
    <div className="main-wrapper">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="content"
      >
        <div className="header">
          <img src={Logo} alt="SuprunVPN" className="logo-image" />
        </div>

        <motion.button
          className="back-btn"
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={20} strokeWidth={2} />
          Назад
        </motion.button>

        <div className="raffle-content">
          {/* Мини-прогресс с призами */}
          <div className="prize-mini-progress">
            <div className="mini-header">
              <Gift size={18} />
              <span>Текущий главный приз</span>
            </div>

            <div className="levels-mini">
              <div
                className={`mini-level ${totalReferrals >= 0 ? 'reached' : ''} ${
                  activeLevel === 1 ? 'active' : ''
                }`}
              >
                <div className="mini-icon">
                  <img
                    src="https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MXP93?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1724766738000"
                    alt="AirPods 4"
                  />
                </div>
                <span className="mini-label">AirPods 4</span>
              </div>

              <div
                className={`mini-level ${totalReferrals >= 150 ? 'reached' : ''} ${
                  activeLevel === 2 ? 'active' : ''
                }`}
              >
                <div className="mini-icon">
                  <img
                    src="https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MWP22?wid=1144&hei=1144&fmt=jpeg&qlt=90&.v=1724177800000"
                    alt="AirPods Pro"
                  />
                </div>
                <span className="mini-label">AirPods Pro</span>
              </div>

              <div
                className={`mini-level ${totalReferrals >= 250 ? 'reached' : ''} ${
                  activeLevel === 3 ? 'active' : ''
                }`}
              >
                <div className="mini-icon">
                  <img
                    src="https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/watch-s11-digitalmat-gallery-4-202509?wid=728&hei=666&fmt=png-alpha&.v=T1pyYVFWN3pudWliRWQ0WTl3UmJXbU1QRDErVGRSejdiZElhV1JWdUVLeUU5aWg1WE9Xd3BOSWtnNzkvSWZLd1RnWXNaUGkzWFF6Q0FVUXZLQlA2QVJRYWgrN0g0OU9tZmI1RTZGaTlLelk5WUpabk42Z1I3OGM1SE5UcVdmaVQ"
                    alt="Apple Watch"
                  />
                </div>
                <span className="mini-label">Watch 11</span>
              </div>

              <div
                className={`mini-level ${totalReferrals >= 610 ? 'reached top' : ''} ${
                  activeLevel === 4 ? 'active' : ''
                }`}
              >
                <div className="mini-icon">
                  <img
                    src="https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-17-digitalmat-gallery-1-202509_GEO_US?wid=728&hei=666&fmt=p-jpg&qlt=95&.v=SVhTK013TmU5bXcxZm9yb0hnWkxGZlRhSXFkOFhqdTgvUmc4VitXa2VzZFRpY3dYYW55S0JhMks5eFdrdlpYK1dwS3BmOE5lS0dKc1dRREcrSXh5V0NrT3VSbnZSMWpmMWVuSlI3UlowWE9ubjJ0K1k4UnQ3UEdjQlkwUWRIWUE"
                    alt="iPhone 17"
                  />
                </div>
                <span className="mini-label">iPhone 17</span>
              </div>
            </div>

            <div className="mini-progress-bar">
              <motion.div
                className="mini-fill"
                initial={{ width: 0 }}
                animate={{ width: `${Math.min(100, (totalReferrals / 610) * 100)}%` }}
                transition={{ duration: 1.4, ease: 'easeOut' }}
              />
              <div className="mini-markers">
                <span style={{ left: '24%' }} />
                <span style={{ left: '41%' }} />
                <span style={{ left: '100%' }} />
              </div>
            </div>

            {nextThreshold && (
              <div className="mini-next">
                Главный приз будет меняться в зависимости от количества участников. 
                {/* <p>До следующего главного приза осталось <strong>{nextThreshold - totalReferrals}</strong> общих приглашённых</p> */}
              </div>
            )}

            {/* {totalReferrals >= 360 && (
              <div className="mini-next" style={{ color: '#ffd700' }}>
                Главный приз достигнут!
              </div>
            )} */}
          </div>
          <p>Ваш ID: <strong>{telegramId}</strong></p>
          {/* Статистика приглашённых пользователем */}
          {referralCount !== null && referralCount > 0 && (
            <div className="referral-stats">
              <p className="referral-count">
                Вы уже пригласили: <strong>{referralCount}</strong>
              </p>
              <p className="referral-hint">
                {referralCount === 1 ? 'пользователя' : 'пользователей'}
              </p>
            </div>
          )}

          <p>
            Участвуйте в розыгрыше призов и выиграйте от AirPods 4 до IPhone 17! 
          </p>
          <p>Чтобы учавствовать и увеличить свои шансы на победу:</p>
          <ul>
            <li>Приглашайте друзей по своей реферальной ссылке</li>
            <li>Каждый приглашенный друг должен приобрести любую подписку от 1 месяца в боте</li>
            <li>Чем больше друзей вы пригласите, тем выше ваши шансы на победу</li>
            <li>Розыгрыш — <strong>13 марта</strong></li>
          </ul>
          <p>
            Призовые места:
          </p>
          <ul>
            <li>1 место — Главный приз</li>
            <li>2 место — 3 месяца подписки</li>
            <li>3 место — 1 месяц подписки</li>
          </ul>

          <motion.button
            className="copy-btn"
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              navigator.clipboard
                .writeText(referralLink)
                .then(() => alert('Ссылка скопирована!'))
                .catch(() => alert('Не удалось скопировать'));
            }}
          >
            <Copy size={20} strokeWidth={2} className="copy-icon" />
            Скопировать реферальную ссылку
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
}

export default RaffleScreen;